import { Stack } from '@mui/material';

import RadioGroup from '../../../../components/FormControls/RadioGroup';
import ClassWidgetSkeleton from '../../../class/ClassWidget/Skeleton';
import { classListClasses, RadioOption } from './styles';

export interface ClassListSkeletonProps {
  className?: string;
}

const ClassListSkeleton = ({ className }: ClassListSkeletonProps) => {
  return (
    <RadioGroup fullWidth className={className}>
      <Stack gap={1.5} px={2} py={0.5} my={-0.5} maxWidth="100%">
        {new Array(3).fill('').map((_, index) => (
          <RadioOption key={index} value={`${index}`}>
            <ClassWidgetSkeleton className={classListClasses.classCard} />
          </RadioOption>
        ))}
      </Stack>
    </RadioGroup>
  );
};

export default ClassListSkeleton;
